import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'トップ' },
    { path: '/services', label: '事業内容' },
    { path: '/works', label: '施工事例' },
    { path: '/company', label: '会社概要' },
    { path: '/recruit', label: '採用情報' },
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className={`text-lg lg:text-xl font-bold whitespace-nowrap ${isScrolled || location.pathname !== '/' ? 'text-primary' : 'text-white'}`}>
              おかやま解体工事株式会社
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors hover:text-secondary whitespace-nowrap ${
                    location.pathname === link.path ? 'text-secondary' : (isScrolled || location.pathname !== '/' ? 'text-primary' : 'text-white')
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Desktop Buttons */}
            <div className="hidden lg:flex items-center space-x-3">
              <a
                href="tel:086-012-3456"
                className="flex items-center space-x-2 px-5 py-2.5 bg-white text-primary rounded-full hover:bg-primary hover:text-white transition-all whitespace-nowrap cursor-pointer border-2 border-white"
              >
                <i className="ri-phone-line"></i>
                <span className="text-sm font-medium">電話する</span>
              </a>
              <Link
                to="/contact"
                className="px-5 py-2.5 bg-primary text-white rounded-full hover:bg-secondary transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled || location.pathname !== '/' ? 'text-primary' : 'text-white'}`}
              aria-label="メニュー"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white lg:hidden">
          <div className="flex flex-col items-center justify-center h-full space-y-8 px-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-2xl font-bold transition-colors ${
                  location.pathname === link.path ? 'text-secondary' : 'text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex flex-col space-y-4 w-full max-w-xs pt-8">
              <a
                href="tel:086-012-3456"
                className="flex items-center justify-center space-x-2 px-6 py-4 border-2 border-primary text-primary rounded-full hover:bg-primary hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="font-medium">電話する</span>
              </a>
              <Link
                to="/contact"
                className="px-6 py-4 bg-primary text-white rounded-full hover:bg-secondary transition-all text-center font-medium whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
